import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incubation',
  templateUrl: './incubation.component.html',
  styleUrls: ['./incubation.component.scss']
})
export class IncubationCentreComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
